<span class="badge badge-cliente-analise-mercado-status-pretendido-badge-pill badge-cliente-analise-mercado-status-pretendido-badge-pill-pretendido"
    [title]="getTitle()">       
</span>